import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { typography } from '../styles';
import { cellPadding, tableFirstColumnCss } from './Table.styled';
export var thCss = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\theight: 46px;\n\tbox-sizing: border-box;\n\tfont-weight: ", ";\n\tcursor: default;\n\tfont-size: ", ";\n\tpadding: ", ";\n\ttext-align: inherit;\n"])), typography.weights.regular, typography.sizes.xsml2, cellPadding);
export var thHiddenCss = function thHiddenCss(props) {
  return props.isHidden && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\theight: 0;\n\t\tpadding-top: 0;\n\t\tpadding-bottom: 0;\n\t\tline-height: 0;\n\t"])));
};
export var StyledTH = styled.th(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t", ";\n\t", ";\n\t", ";\n"])), tableFirstColumnCss, function (props) {
  return props.children && thCss;
}, thHiddenCss);